import Box from '@material-ui/core/Box';
import {withStyles} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import React, {FC, ReactElement, ReactNode} from 'react';
import Skeleton, {SkeletonProps} from '@material-ui/lab/Skeleton';

import {ContainerProps, ItemWrapper, useContainerStyles} from './styles';

export interface ItemProps {
    children: ReactNode;
    label: ReactElement;
    secondaryText?: ReactElement;
    loading?: boolean;
}

const Item: FC<ItemProps> = ({label, children, secondaryText, loading}: ItemProps) => {
    if (loading) {
        return <ChartOverview.Skeleton />;
    }

    return (
        <ItemWrapper>
            <Typography variant="caption" color="textSecondary">
                {label}
            </Typography>
            <div>
                <Typography variant="h4">{children}</Typography>
                {secondaryText}
            </div>
        </ItemWrapper>
    );
};

const ItemSkeleton = withStyles(theme => ({
    root: {
        width: '100%',
        height: '100%',
        minWidth: 150,
        minHeight: 60,
        borderRadius: theme.shape.borderRadius
    }
}))(props => <Skeleton variant="rect" {...props} />);

interface ChartSummaryType extends FC<ContainerProps> {
    Item: FC<ItemProps>;
    Skeleton: FC<SkeletonProps>;
}

export const ChartOverview: ChartSummaryType = ({
    gridTemplateColumnsSM,
    gridTemplateColumns,
    ...props
}: ContainerProps) => {
    const classes = useContainerStyles({gridTemplateColumnsSM, gridTemplateColumns});

    return <Box {...props} className={classes.root} />;
};

ChartOverview.Item = Item;
ChartOverview.Skeleton = ItemSkeleton;

export default ChartOverview;
